'use strict';

passwordValidator.$inject = ['$log'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = passwordValidator;
/**
 * Created by stefano on 24/08/16.
 */
function passwordValidator($log) {
  'ngInject';

  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ctrl) {
      var at_list_a_number = /^.*\d.*$/i;
      var at_list_a_letter = /^.*[a-zA-Z]+.*$/i;
      var ripetition = /.*(.)\1\1.*$/i;

      //attrs.mailblacklisted = "filippo.buletto@svilcert.legalmail.it filippo.buletto.test@svilcert.legalmail.it";
      elem.bind('blur', function (evt) {
        scope.$apply(function () {
          var value = elem.val();

          if (at_list_a_number.test(value) == false || at_list_a_letter.test(value) == false || ripetition.test(value) == true) {
            $log.debug("password not valid");
            ctrl.$setValidity('passwordvalidator', false);
          } else {
            $log.debug("password valid");
            ctrl.$setValidity('passwordvalidator', true);
          }
        });
      });

      elem.bind('keyup', function (evt) {
        scope.$apply(function () {
          var value = elem.val();

          if (at_list_a_number.test(value) == false || at_list_a_letter.test(value) == false || ripetition.test(value) == true) {
            ctrl.$setValidity('passwordvalidator', false);
          } else {
            ctrl.$setValidity('passwordvalidator', true);
          }
        });
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/passwordValidator.js
// module id = 150
// module chunks = 2